import { TypeState } from '..'

import styles from './styles.module.scss'

import { Loader } from '@/components/Loader'

import { courseStore } from '@/stores/course.store'
import { Course } from '@/domain/entities/course.entity'
import { useUpdateCourse } from '@/pages/@hooks/use-update-course'
import { CoursesService } from '@/services/courses/course.service'

interface IProps {
  setState: React.Dispatch<React.SetStateAction<TypeState>>
  editingCurso: Course
  setEditingCurso: React.Dispatch<React.SetStateAction<Course>>
}

const courseService = new CoursesService()

export const UpdateCourse = ({
  setState,
  editingCurso,
  setEditingCurso,
}: IProps) => {
  const { setCourses, courses } = courseStore()
  const { isPending, updateCourse } = useUpdateCourse({ courseService })

  async function updateCourseCallback(course: Course) {
    const [response] = await updateCourse(course)
    const coursesFiltered = courses.filter(
      (course) => course.id !== response.id,
    )
    setCourses([...coursesFiltered, response])
    setState('CURSOS')
  }

  const onChange = (key: keyof Course, value: Course[keyof Course]) =>
    setEditingCurso((state) => ({ ...state, [key]: value }))

  return (
    <div className={styles.form_container}>
      {isPending && <Loader />}
      <p>Editando course: {editingCurso?.name}</p>

      <select
        value={editingCurso.category_id}
        onChange={(e) => onChange('category_id', +e.target.value)}
      >
        <option value={'2'}>Ensino Básico</option>
        <option value={'3'}>Técnico</option>
        <option value={'4'}>Profissionalizante</option>
        <option value={'5'}>EJA</option>
        <option value={'6'}>Idiomas</option>
        <option value={'7'}>Pré-Vestibular / Preparatório</option>
        <option value={'8'}>Infantil</option>
        <option value={'9'}>Período Integral</option>
      </select>
      <select
        value={editingCurso.modality?.toUpperCase()}
        onChange={(e) => onChange('modality', e.target.value)}
      >
        <option value={''}>NAO TEM</option>
        <option value={'PRESENCIAL'}>PRESENCIAL</option>
        <option value={'EAD'}>EAD</option>
      </select>
      <select
        value={editingCurso.shift?.toUpperCase()}
        onLoad={(e) => onChange('shift', e.currentTarget.value)}
        onChange={(e) => onChange('shift', e.target.value)}
      >
        <option value={'MANHA'}>MANHA</option>
        <option value={'TARDE'}>TARDE</option>
        <option value={'NOITE'}>NOITE</option>
      </select>

      <select
        value={editingCurso.status?.toUpperCase()}
        onChange={(e) => onChange('status', e.target.value)}
      >
        <option value={''}>NAO TEM</option>
        <option value={'ATIVO'}>ATIVO</option>
        <option value={'BLOQUEADO'}>BLOQUEADO</option>
      </select>
      <input
        onChange={(e) => onChange('name', e.target.value)}
        placeholder="titulo"
        value={editingCurso?.name}
      />
      <input
        onChange={(e) => onChange('scholarship_year', Number(e.target.value))}
        placeholder="ano bolsa"
        value={editingCurso?.scholarship_year}
      />
      <input
        onChange={(e) => onChange('vacancies', +e.target.value)}
        placeholder="vagas"
        value={editingCurso?.vacancies}
      />
      <input
        onChange={(e) => onChange('description', e.target.value)}
        placeholder="descrições"
        value={editingCurso?.description}
      />
      <input
        onChange={(e) => onChange('amount', e.target.value)}
        placeholder="valor"
        value={editingCurso?.amount}
      />
      <input
        onChange={(e) => onChange('promotional_value', e.target.value)}
        placeholder="valor promocional"
        value={editingCurso?.promotional_value}
      />
      <input
        onChange={(e) => onChange('percent', e.target.value)}
        placeholder="percentual"
        value={editingCurso?.percent}
      />
      <button onClick={() => updateCourseCallback(editingCurso)}>
        Atualizar Curso
      </button>
    </div>
  )
}
